import {
  AboutComponent,
  BackendService,
  BrandConfig,
  BrandConfigProtocol,
  BrandService,
  ConfigService,
  ElectraComponent,
  ElectraDesktopComponent,
  FilterComponent,
  HeaderComponent,
  HeaderWrapperComponent,
  IABComponent,
  LegendComponent,
  MapComponent,
  MapService,
  MenuComponent,
  MenuWrapperComponent,
  MoreComponent,
  SearchComponent,
  SearchResultsComponent,
	SearchService,
  SearchWrapperComponent,
  SlideBarComponent,
  SplashComponent,
  StateService,
  SubPageHeaderComponent,
  TermsComponent,
  TokenService,
  UtilityService
}                       from './';
import { CommonModule } from '@angular/common';
import {
	FormBuilder,
	FormsModule,
	ReactiveFormsModule
}												from '@angular/forms';
import { HttpModule }		from '@angular/http';
import {
  ModuleWithProviders,
  NgModule
}                       from '@angular/core';

@NgModule({
  declarations: [
    AboutComponent,
    ElectraComponent,
    ElectraDesktopComponent,
    FilterComponent,
    HeaderComponent,
    HeaderWrapperComponent,
		IABComponent,
    LegendComponent,
    MapComponent,
    MenuComponent,
    MenuWrapperComponent,
		MoreComponent,
    SearchComponent,
    SearchResultsComponent,
    SearchWrapperComponent,
    SlideBarComponent,
    SplashComponent,
    SubPageHeaderComponent,
		TermsComponent
  ],
  exports: [ 
    ElectraComponent,
    ElectraDesktopComponent
  ],
  imports: [
		CommonModule,
    FormsModule,
    HttpModule,
    ReactiveFormsModule
  ]
})
export class ElectraModule {
  static forRoot(brandConfig: BrandConfigProtocol): ModuleWithProviders {
    return {
      ngModule: ElectraModule,
      providers: [
        BackendService,
				BrandService,
        ConfigService,
        FormBuilder,
        MapService,
				SearchService,
        StateService,
        TokenService,
        UtilityService,
        { provide: BrandConfig, useValue: brandConfig }
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/electraLib/electra.module.ts